import React, { useState } from "react";
import ReportName from "./NameSection";
import { Box } from "@material-ui/core";
import ReportList from "./ReportList";
import { useDispatch, useSelector } from "react-redux";
import {
  selectReportCategories,
  selectStatusDefaultCategory,
} from "../../controllers/selectors";
import { useTranslation } from "react-i18next";
import { Divider } from "@mui/material";
import {
  getPermissionViewDetailProject,
  getPermissionViewUser,
} from "actions/viewPermissions";

const ReportSetting = ({ projectId, handleEditCategory }) => {
  const dispatch = useDispatch();
  React.useLayoutEffect(() => {
    dispatch(getPermissionViewDetailProject({ projectId }));
    // eslint-disable-next-line
  }, []);
  const reportCategories = useSelector(selectReportCategories());
  const statusDefaultCategory = useSelector(selectStatusDefaultCategory());
  const { t } = useTranslation();

  return (
    <Box style={{ width: "100%" }}>
      <Box>
        <ReportName projectId={projectId} isDefaultCategory={true} />
      </Box>
      <Divider
        sx={{ margin: "20px 0px", height: "1px", borderBottomWidth: "0px" }}
      />
      {reportCategories.map((item, index) => (
        <ReportSettingItem
          projectId={projectId}
          key={index}
          report={item}
          handleEditCategory={handleEditCategory}
        />
      ))}
    </Box>
  );
};

ReportSetting.propTypes = {};

export default ReportSetting;

export const ReportSettingItem = ({
  projectId,
  report,
  defaultCollapse = false,
  handleEditCategory,
}) => {
  const [isCollapse, setIsCollapse] = useState(defaultCollapse);
  return (
    <>
      <ReportName
        projectId={projectId}
        report={report}
        isCollapse={isCollapse}
        setIsCollapse={setIsCollapse}
        handleEditCategory={handleEditCategory}
      />
      {!isCollapse && <ReportList report={report} />}
      <Divider
        sx={{ margin: "20px 0px", height: "1px", borderBottomWidth: "0px" }}
      />
    </>
  );
};
